/* eslint-disable no-unused-vars */
import React from "react";
import TopBar from "../components/TopBar";
import { useState } from "react";
import { getUserNotifications } from "../services/btc-api.service";
import { useEffect } from "react";
import { useSelector } from "react-redux";
const moment = require('moment');

export default function Notification() {
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const getNotifications = async () => {
    const res = await getUserNotifications(limit, page);

    setRecords(res.records);
    setTotalRecords(res.totalRecords);
  }

  useEffect(() => {
    getNotifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <TopBar />
      <div className="auction-page container-fluid">
        <div className="title-and-pagination">
          <h1>Notifications</h1>
        </div>
        <div className="auction-info">
          <div
            className="process-card"
            style={{ padding: "60px 30px", paddingBottom: 100 }}
          >
            <div className="col">
              <div className="tabs">
                {records && records.length > 0 && records.map((notification, index) => (
                  <NotificationAccordion
                    key={index}
                    date={notification.createdAt}
                    content={notification.notificationText}
                    subject={notification.subject}
                    id={`chck${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const NotificationAccordion = ({ date, content, id, subject }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const user = useSelector(state => state.user.user);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`tab ${isOpen ? "active" : ""}`}>
      <input className="hidden" type="checkbox" id={id} />
      <label className="tab-label" htmlFor={id} onClick={toggleAccordion}>
        <div>
          <b>{moment(date).format('YYYY/mm/DD')} {moment(date).format("hh:mm:ss a")}</b>  <span style={{ marginLeft: 50 }} >{subject}</span>

        </div>
        <i className={`fa ${isOpen ? "fa-angle-up" : "fa-angle-down"}`} />
      </label>
      <div className="tab-content">
        <b>Hi {user && user.username},</b>
        <br />
        <br />
        {content}
      </div>
    </div>
  );
};
